/* Cazameeza PDP intelligence — metafield facts first (Phase 1, Oct 2026), live-product second, static content optional. */
(function () {
  'use strict';
  if (window.__cazaPdpLowerLiveV6) return;
  window.__cazaPdpLowerLiveV6 = true;

  var contentCache = null;
  var catalogCache = null;
  var liveCache = null;
  var factsCache = null;

  function q(selector, root) { return (root || document).querySelector(selector); }
  function qa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function normalize(value) { return String(value == null ? '' : value).replace(/\s+/g, ' ').trim().toLowerCase(); }

  function config() {
    var node = q('#caza-winter-pdp-config');
    if (!node) return {};
    try { return JSON.parse(node.textContent || '{}'); } catch (e) { return {}; }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function loadJson(url) {
    if (!url || !window.fetch) return Promise.resolve({});
    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('unavailable'); return r.json(); })
      .catch(function () { return {}; });
  }

  function loadContent() {
    if (contentCache) return Promise.resolve(contentCache);
    return loadJson(config().contentUrl).then(function (data) {
      contentCache = data && data.products ? data.products : (data || {});
      return contentCache;
    });
  }

  function loadCatalog() {
    if (catalogCache) return Promise.resolve(catalogCache);
    var cfg = config();
    var url = cfg.catalogUrl || String(cfg.taxonomyUrl || '').replace('caza-winter-taxonomy.json', 'caza-active-catalog.json');
    return loadJson(url).then(function (data) {
      catalogCache = data && data.products ? data.products : (data || {});
      return catalogCache;
    });
  }

  function loadLiveProduct() {
    if (liveCache) return Promise.resolve(liveCache);
    var handle = config().handle;
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('product unavailable'); return r.json(); })
      .then(function (product) { liveCache = product; return product; })
      .catch(function () { return null; });
  }

  function localePrefix() {
    var p = window.location.pathname || '';
    return /^\/ar(\/|$)/.test(p) ? '/ar' : '';
  }

  function loadFacts() {
    if (factsCache) return Promise.resolve(factsCache);
    var handle = config().handle;
    if (!handle || !window.fetch) return Promise.resolve({});
    return fetch(localePrefix() + '/products/' + encodeURIComponent(handle) + '?view=caza-facts', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('facts unavailable'); return r.text(); })
      .then(function (text) { var data = JSON.parse(text); factsCache = data && data.ok ? data : {}; return factsCache; })
      .catch(function () { factsCache = {}; return factsCache; });
  }

  function hasFacts(data) {
    var f = data && data.facts;
    return !!(f && (f.fabric || f.whats_included || f.fit_note || f.care || f.model_info || f.length_top_cm || f.length_bottom_cm));
  }

  function categoryFromProduct(product) {
    var value = normalize((product && product.type) || '');
    var title = normalize((product && product.title) || '');
    var source = value + ' ' + title;
    if (source.indexOf('jumpsuit') !== -1) return 'jumpsuit';
    if (source.indexOf('abaya') !== -1) return 'abaya';
    if (source.indexOf('dress') !== -1) return 'dress';
    if (source.indexOf('pant') !== -1 || source.indexOf('trouser') !== -1 || source.indexOf('culotte') !== -1) return 'pants';
    if (source.indexOf('outerwear') !== -1 || source.indexOf('jacket') !== -1 || source.indexOf('cardigan') !== -1 || source.indexOf('shawl') !== -1 || source.indexOf('kimono') !== -1) return 'outerwear';
    if (source.indexOf('set') !== -1 || source.indexOf('suit') !== -1 || source.indexOf('ensemble') !== -1) return 'set';
    if (source.indexOf('top') !== -1 || source.indexOf('pullover') !== -1 || source.indexOf('shirt') !== -1 || source.indexOf('blouse') !== -1) return 'top';
    return 'other';
  }

  function pieceCount(product) {
    var source = normalize(((product && product.title) || '') + ' ' + ((product && product.description) || '').replace(/<[^>]+>/g, ' '));
    var match = source.match(/\b([2-5])\s*[- ]?piece/);
    return match ? Number(match[1]) : 0;
  }

  function genericContent(entry) {
    if (!entry) return {};
    var count = Number(entry.pieceCount || 0);
    var category = entry.category || 'other';
    if (category === 'set') return { about: count > 1 ? 'A coordinated ' + count + '-piece set designed to make the outfit decision easier.' : 'A coordinated set designed to make the outfit decision easier.', details: [count > 1 ? 'Coordinated ' + count + '-piece set.' : 'Coordinated set.'], included: [count > 1 ? count + ' coordinated pieces.' : 'One coordinated set.'] };
    if (category === 'top') return { about: 'A standalone top designed for easy mix-and-match styling across different looks.', details: ['Standalone top designed to pair with different bottoms.'], included: ['One top.'] };
    if (category === 'pants') return { about: 'Standalone pants designed to make mix-and-match styling easier across different looks.', details: ['Standalone pants designed for mix-and-match styling.'], included: ['One pair of pants.'] };
    if (category === 'outerwear') return { about: 'A standalone outer layer designed to finish different outfits without rebuilding the whole look.', details: ['Standalone outer layer.'], included: ['One outerwear piece.'] };
    if (category === 'dress') return { about: 'A one-piece dress designed to keep the outfit decision simple while letting the silhouette carry the look.', details: ['One-piece dress.'], included: ['One dress.'] };
    if (category === 'abaya') return { about: 'A one-piece abaya designed as a complete standalone look with simple styling around it.', details: ['Standalone abaya.'], included: ['One abaya.'] };
    if (category === 'jumpsuit') return { about: 'A one-piece jumpsuit designed to give you a complete look in one outfit decision.', details: ['One-piece jumpsuit.'], included: ['One jumpsuit.'] };
    return {};
  }

  function sectionValues(box, matcher) {
    var headings = qa('h2,h3,h4,strong', box);
    for (var i = 0; i < headings.length; i += 1) {
      if (!matcher.test(normalize(headings[i].textContent))) continue;
      var node = headings[i].nextElementSibling;
      if (!node && headings[i].parentElement) node = headings[i].parentElement.nextElementSibling;
      if (!node) return [];
      if (node.matches && node.matches('ul,ol')) return qa('li', node).map(function (li) { return li.textContent.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      return text ? [text] : [];
    }
    return [];
  }

  function contentFromLive(product) {
    if (!product) return {};
    var base = genericContent({ category: categoryFromProduct(product), pieceCount: pieceCount(product) });
    var box = document.createElement('div');
    box.innerHTML = product.description || '';
    var firstP = q('p', box);
    var about = firstP ? (firstP.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var details = sectionValues(box, /why you.?ll love it|why you will love it/);
    var included = sectionValues(box, /what.?s included|what is included/);
    var fit = sectionValues(box, /size\s*&\s*fit|size and fit/);
    var fabric = sectionValues(box, /fabric\s*&\s*feel|fabric and feel|fabric/);
    var care = sectionValues(box, /care/);
    return {
      about: about || base.about || '',
      details: details,
      included: included,
      fit: fit,
      fabric: fabric,
      care: care
    };
  }

  function resolveContent(content, catalog, live) {
    var handle = config().handle;
    if (content && content[handle]) return content[handle];
    if (live) return contentFromLive(live);
    if (catalog && catalog[handle]) return genericContent(catalog[handle]);
    return {};
  }

  function optionByName(name) {
    var targets = [].concat(name).map(normalize);
    return qa('.t4s-section-main-product .t4s-swatch__option').find(function (option) {
      var title = q('.t4s-swatch__title', option);
      var text = normalize(title ? title.textContent : '');
      return targets.some(function (t) { return text.indexOf(t) !== -1; });
    }) || null;
  }

  function selectableSizes() {
    var option = optionByName(['size', 'مقاس']);
    if (!option) return [];
    var seen = {};
    return qa('.t4s-swatch__item', option).filter(function (item) {
      return !item.classList.contains('is--soldout') && item.getAttribute('aria-disabled') !== 'true';
    }).map(function (item) {
      return (item.getAttribute('data-value') || item.textContent || '').replace(/\s+/g, ' ').trim();
    }).filter(function (value) {
      if (!value || seen[value]) return false;
      seen[value] = true; return true;
    });
  }

  function listHtml(items) {
    if (!items || !items.length) return '';
    return '<ul>' + items.map(function (item) { return '<li>' + escapeHtml(item) + '</li>'; }).join('') + '</ul>';
  }

  function rowHtml(title, body, open) {
    if (!body) return '';
    return '<details' + (open ? ' open' : '') + '><summary>' + escapeHtml(title) + '</summary><div class="caza-v5-intelligence__body">' + body + '</div></details>';
  }

  function openSize() {
    var trigger = q('[data-caza-size-open]');
    if (trigger) trigger.click();
  }

  function buildModel(productContent, factsData) {
    productContent = productContent || {};
    var withFacts = hasFacts(factsData);
    var f = withFacts ? factsData.facts : {};
    var L = (factsData && factsData.labels) || {};
    var rows = [];
    if (!withFacts && productContent.details && productContent.details.length) rows.push({ title: 'Product details', body: listHtml(productContent.details), open: true });
    var fabricItems = [f.fabric, f.thickness, f.stretch].filter(Boolean);
    if (fabricItems.length) rows.push({ title: L.row_fabric || 'Fabric & feel', body: listHtml(fabricItems), open: true });
    var sizes = selectableSizes();
    var fitParts = [];
    var factFit = [];
    if (f.fit_note) factFit.push(f.fit_note);
    if (f.length_top_cm) factFit.push((L.top_length || 'Top length (size L)') + ': ' + f.length_top_cm + ' ' + (L.cm || 'cm'));
    if (f.length_bottom_cm) factFit.push((L.bottom_length || 'Pants length (size L)') + ': ' + f.length_bottom_cm + ' ' + (L.cm || 'cm'));
    if (f.model_info) factFit.push(f.model_info);
    if (factFit.length) fitParts.push(listHtml(factFit));
    else if (productContent.fit && productContent.fit.length) fitParts.push(listHtml(productContent.fit));
    var oneSize = sizes.length === 1 && /one size|مقاس واحد/.test(normalize(sizes[0]));
    if (sizes.length && !oneSize) {
      fitParts.push('<p>' + escapeHtml(L.sizes_now || 'Currently available sizes') + ': ' + escapeHtml(sizes.join(', ')) + '.</p>');
      fitParts.push('<button type="button" class="caza-v5-intelligence__action" data-caza-v5-size>' + escapeHtml(L.size_help || 'Open size help →') + '</button>');
    } else if (sizes.length) {
      fitParts.push('<p>' + escapeHtml(L.one_size || 'One size.') + '</p>');
    }
    if (fitParts.length) rows.push({ title: L.row_fit || 'Size & fit', body: fitParts.join(''), open: false });
    if (!fabricItems.length && productContent.fabric && productContent.fabric.length) rows.push({ title: 'Fabric & feel', body: listHtml(productContent.fabric), open: false });
    if (f.whats_included) {
      var inc = [f.whats_included];
      if (f.not_included) inc.push((L.not_included || 'Not included') + ': ' + f.not_included);
      rows.push({ title: L.row_included || 'What’s included', body: listHtml(inc), open: true });
    } else if (!withFacts && productContent.included && productContent.included.length) {
      rows.push({ title: 'What’s included', body: listHtml(productContent.included), open: false });
    }
    if (f.care) rows.push({ title: L.row_care || 'Care', body: listHtml([f.care]), open: false });
    else if (productContent.care && productContent.care.length) rows.push({ title: 'Care', body: listHtml(productContent.care), open: false });
    return { about: productContent.about || '', rows: rows, faq: (factsData && factsData.faq_html) || '' };
  }

  function quickFactsHtml(factsData) {
    if (!factsData || !factsData.facts) return '';
    var f = factsData.facts, L = factsData.labels || {};
    var items = [];
    if (f.fabric) items.push((L.fabric || 'Fabric') + ': ' + f.fabric);
    if (f.whats_included) items.push((L.included || 'In your order') + ': ' + f.whats_included);
    if (f.sizes) items.push((L.sizes || 'Sizes') + ': ' + f.sizes);
    if (!items.length) return '';
    return '<div class="caza-v4-piece-reasons caza-quick-facts"><span>' + escapeHtml(L.quick || 'Quick facts') + '</span><ul>' + items.map(function (i) { return '<li>' + escapeHtml(i) + '</li>'; }).join('') + '</ul></div>';
  }

  function applyQuickFacts(factsData) {
    return; // Oct 7: Ahmed keeps the original intro + 'Why this piece' story; quick facts disabled.
    var html = quickFactsHtml(factsData);
    if (!html) return;
    var story = q('.t4s-section-main-product .caza-v4-product-story');
    if (!story) return;
    if (story.getAttribute('data-caza-first-paint') === '1' && q('.caza-quick-facts', story)) return;
    if (story.getAttribute('data-caza-facts-sig') === html && q('.caza-quick-facts', story)) return;
    story.innerHTML = html;
    story.setAttribute('data-caza-facts-sig', html);
  }

  function bindFaq(section) {
    var policy = q('[data-caza-faq-policy]', section);
    if (policy && !policy.dataset.bound) {
      policy.dataset.bound = '1';
      policy.addEventListener('click', function () { var tab = document.getElementById('cm-policy-tab'); if (tab) tab.click(); });
    }
    var size = q('[data-caza-faq-size]', section);
    if (size && !size.dataset.bound) { size.dataset.bound = '1'; size.addEventListener('click', openSize); }
  }

  function render(productContent) {
    var container = q('.caza-pdp-v4 .t4s-product__info-container') || q('.t4s-section-main-product .t4s-product__info-container');
    if (!container) return;
    var anchor = q('.caza-v4-trust', container) || q('.t4s-product-form__buttons', container) || q('form.t4s-form__product', container);
    if (!anchor) return;
    var model = buildModel(productContent, factsCache);
    var signature = JSON.stringify(model);
    var section = q('.caza-v5-intelligence', container);
    if (!model.about && !model.rows.length && !model.faq) { if (section) section.style.display = 'none'; return; }
    if (!section) {
      section = document.createElement('section');
      section.className = 'caza-v5-intelligence';
      anchor.insertAdjacentElement('afterend', section);
    }
    if (section.dataset.cazaSignature === signature) return;
    section.dataset.cazaSignature = signature;
    section.style.removeProperty('display');
    section.innerHTML =
      (model.about ? '<div class="caza-v5-about-block"><span class="caza-v5-intelligence__eyebrow">PRODUCT STORY</span><h2>About this piece</h2><p>' + escapeHtml(model.about) + '</p></div>' : '') +
      (model.rows.length ? '<div class="caza-v5-intelligence__head"><span class="caza-v5-intelligence__eyebrow">PRODUCT DETAILS</span><h2>Details before you order</h2></div><div class="caza-v5-intelligence__rows">' + model.rows.map(function (row) { return rowHtml(row.title, row.body, row.open); }).join('') + '</div>' : '') +
      (model.faq || '');
    var sizeButton = q('[data-caza-v5-size]', section);
    if (sizeButton) sizeButton.addEventListener('click', openSize);
    bindFaq(section);
  }

  function boot() {
    Promise.all([loadContent(), loadCatalog(), loadLiveProduct(), loadFacts()]).then(function (parts) {
      var productContent = resolveContent(parts[0], parts[1], parts[2]);
      render(productContent);
      applyQuickFacts(factsCache);
      document.addEventListener('variant:changed', function () { window.setTimeout(function () { render(productContent); }, 0); });
      if (!window.MutationObserver) return;
      var productRoot = q('.t4s-section-main-product');
      if (!productRoot) return;
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () { scheduled = false; render(productContent); applyQuickFacts(factsCache); });
      }).observe(productRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-disabled'] });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
